// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Urh4","controls":"styles_controls__3cGa7","charLimit":"styles_charLimit__3qVc8","input":"styles_input__2_O4n","send":"styles_send__3GN85"};